.main {
  border-style: solid;
  border: #0a0a0a;
  border-width: 1px;
}

.icon {
  width: 25px;
  height: 25px;
  stroke: var(--color-blue-violet);
}

.circle {
  background-color: var(--color-gray-200);
  cursor: pointer;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin: 3px;
}

.header {
  display: flex;
}

.civilPanelSpacer {
  padding-top: 10px;
  padding-right: 10px;
}

.civilPanel {
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 7px;
}

.btn {
  border-style: solid;
  border-width: 1px;
}

.buttonGroup {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 10px;
}
